import React from 'react';
import { FaGithub } from 'react-icons/fa';
import websiteImage1 from '../assets/Website/home.png';
import websiteImage2 from '../assets/Website/about.png';
import websiteImage3 from '../assets/Website/contact.png';
import websiteImage4 from '../assets/Website/services.png';

import GpImage1 from '../assets/GP/home.png';
import GpImage2 from '../assets/GP/control.png';
import GpImage3 from '../assets/GP/scan.png';
import GpImage4 from '../assets/GP/fit-line.png';
import GpImage5 from '../assets/GP/team.png';
import Slider from './Slider';

const Projects = () => {
  const Websiteimages = [websiteImage1, websiteImage2,websiteImage3,websiteImage4];
  const GPimages = [GpImage1, GpImage2, GpImage3, GpImage4, GpImage5];

  return (
    <>
      <h2 className="text-2xl font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Projects</h2>
      <div className="space-y-4 pb-10 pr-3">
        <Slider
          images={Websiteimages}
          description="A full-stack web application built with React, Tailwind CSS, Node.js, and MongoDB. It is a CV."
          githubLink="https://github.com/minaa66/my-first-website"
          title={<><span>My-First-website</span> <FaGithub className="ml-2 text-gray-700 dark:text-white" /></>}
        />
        <Slider
          images={GPimages}
          description="A Spectrophotometer device that makes some measurements and displays them on our webpage using a WebSocket connection between the webpage and the ESP32, which is connected to the rest of the hardware."
          githubLink="https://github.com/AhmedAtia1507/Spectrophotometer_GP/tree/main/ESP/webpage"
          title={<><span>Graduation Project</span> <FaGithub className="ml-2 text-gray-700 dark:text-white" /></>}
        />
      </div>
    </>
  );
};

export default Projects;
